import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppConfig } from '../../../core';

export default function RecruitBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(
      'culturalHubRecruitBannerDismissed',
    );
    setVisible(dismissed !== 'true');
  }, []);

  const handleClose = () => {
    setVisible(false);
    window.localStorage.setItem('culturalHubRecruitBannerDismissed', 'true');
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 64,
        width: '100%',
        background:
          'linear-gradient(120deg, rgba(37, 79, 67, 0.96), rgba(56, 102, 93, 0.96))',
        color: '#f6f4ef',
        px: { xs: 2, sm: 3 },
        py: { xs: 1.5, sm: 2 },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1.5, md: 2 },
        borderBottom: '1px solid rgba(246, 244, 239, 0.22)',
        boxShadow: '0 10px 24px rgba(19, 34, 30, 0.18)',
        zIndex: 1200,
        animation: 'banner-slide-in 420ms ease-out',
        '@keyframes banner-slide-in': {
          from: {
            opacity: 0,
            transform: 'translateY(-10px)',
          },
          to: {
            opacity: 1,
            transform: 'translateY(0)',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4 }}>
        <Typography
          variant="overline"
          sx={{
            color: 'rgba(246, 244, 239, 0.82)',
            letterSpacing: '0.08em',
            lineHeight: 1.2,
          }}
        >
          COMMUNITY CALL
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, lineHeight: 1.35, color: '#f6f4ef' }}
        >
          Help preserve African heritage in living detail.
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'rgba(246, 244, 239, 0.9)', lineHeight: 1.45 }}
        >
          Share records, recipes, names, proverbs, songs, and oral histories
          from your family and community.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Button
          variant="contained"
          color="secondary"
          href={`mailto:${AppConfig.appContactEmail}`}
          sx={{
            whiteSpace: 'nowrap',
            fontWeight: 700,
            borderRadius: 2,
            color: 'primary.main',
            px: 2,
          }}
          disableElevation
        >
          Become a contributor
        </Button>

        <IconButton
          color="inherit"
          onClick={handleClose}
          sx={{
            ml: 0.25,
            border: '1px solid rgba(246, 244, 239, 0.28)',
            borderRadius: 1.5,
            '&:hover': {
              backgroundColor: 'rgba(246, 244, 239, 0.12)',
            },
          }}
          aria-label="Dismiss recruit banner"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
